import { useSetupGuideState } from '~/presentation/common/components/GSetupGuide/useSetupGuideState';
import { useUserActionHandlers } from '~/hooks/useUserActionHandlers';
import { PRICE_SETUP_GUIDE_SEEN_ACTION } from '../constants';
import { EPersistKey } from '~/types/persist';
import { useEffectRunOnce } from '~/hooks';
import { useCallback } from 'react';

interface IProps {
  /** Hold off until the step statuses are known, so the guide never opens on a blank list. */
  isReady: boolean;
}

/**
 * Price testing opens its Setup guide the first time a shop lands on the feature and stays
 * closed on every later visit, whatever the shared open/closed state says.
 */
export const usePriceSetupGuideFirstVisit = ({ isReady }: IProps): void => {
  const { setShowSetupGuide } = useSetupGuideState();
  const { actions, hasActionTypeInStore, setUserActionBy } = useUserActionHandlers({
    persistKey: EPersistKey.SETUP_GUIDE_PRICE_SEEN,
  });

  const handleFirstVisit = useCallback(() => {
    const hasSeenSetupGuide = actions?.[PRICE_SETUP_GUIDE_SEEN_ACTION] === 'true';
    setUserActionBy(PRICE_SETUP_GUIDE_SEEN_ACTION, 'true');

    if (hasSeenSetupGuide) return;

    setShowSetupGuide();
  }, [actions, setUserActionBy, setShowSetupGuide]);

  useEffectRunOnce(handleFirstVisit, isReady && hasActionTypeInStore);
};
